import promotion from '../../promotion_config';
import apiClient from 'whitelabel_api_requests';

export default () => {
    return apiClient(promotion.apiClientConfig);
};
